import React from 'react';
import { Col, Button, Modal } from 'react-bootstrap';

const ChooseAppPlatformModal = props => (
  <Modal show={props.show} className="modal-pass want-unsubscribe instructions-link choice-page">
    {/*<span className="litpog-remove" onClick={props.onHide} />*/}
    <Col md={12}>
      <Modal.Body>Where would you like to open this page?</Modal.Body>
    </Col>
    <Col md={12}>
      <Modal.Footer className="footer-ok-buttons">
        <Button className="buttons-ok" onClick={props.onHide}>
          <span className="buttons-ok-text">Open in Browser</span>
        </Button>
        <Button className="buttons-ok" onClick={props.handleOpenInAppClick}>
          <span className="buttons-ok-text">Open in App</span>
        </Button>
      </Modal.Footer>
    </Col>
    <Col md={12}>
      <Modal.Body className="text-under-link">
        Before choosing App, please be sure to download{' '}
        <a href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8">
          Presence on the App Store
        </a>
        .
      </Modal.Body>
    </Col>
  </Modal>
);

export default ChooseAppPlatformModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/ChooseAppPlatformModal.js